import React from 'react';

interface EdgeFadeProps {
  fades?: Array<'fade-top' | 'fade-bottom' | 'fade-left' | 'fade-right'>;
  surface?: 'sf-1' | 'sf-2' | 'sf-3' | 'sf-4';
}

// example usage: <EdgeFade fades={['fade-left', 'fade-right']} />

const EdgeFade: React.FC<EdgeFadeProps> = ({ fades = [], surface = 'sf-1' }) => {
  return (
    <>
      {fades.includes('fade-top') && <div className={`edge-fade fade-top ${surface}`} />}
      {fades.includes('fade-bottom') && <div className={`edge-fade fade-bottom ${surface}`} />}
      {fades.includes('fade-left') && <div className={`edge-fade fade-left ${surface}`} />}
      {fades.includes('fade-right') && <div className={`edge-fade fade-right ${surface}`} />}
    </>
  );
};

export default EdgeFade;
